import axios from "axios";

import { ENDPOINT } from "../../constant/environment";
import { decryptData, encryptData, getHeaderConfig } from "../../utils/api/encryption";
import { consoleLog } from "../../utils/consoleLog/consoleLog";
import { isValidJWT } from "../../utils/authentication/isValidJWT";

export async function getHistoryAPICall(accessJWT: string, userId: string, skip: number, take: number) {
  const URL = `${ENDPOINT}/app/v1/users/history/userId`;
  const body = {
    userId: userId,
    skip: skip,
    take: take,
  };
  let config = getHeaderConfig(null, accessJWT);
  try {
    if (!userId || !accessJWT || !isValidJWT(accessJWT)) return null;
    const response = await axios.post(URL, encryptData(body), config);
    if (response?.data) {
      const decryptedData = decryptData(response?.data);
      consoleLog(["HISTORY LIST", decryptedData ? JSON.parse(decryptedData)?.data : null])
      return decryptedData ? JSON.parse(decryptedData)?.data : null;
    } else return null;
  } catch (error: any) {
    return null;
  }
}


export async function getSingleHistoryAPICall(accessJWT: string, id: string) {
  const URL = `${ENDPOINT}/app/v1/users/historyId`;
  const body = {
    id
  };
  let config = getHeaderConfig(null, accessJWT);
  try {
    if (!accessJWT || !isValidJWT(accessJWT)) return null;
    const response = await axios.post(URL, encryptData(body), config);
    if (response?.data) {
      const decryptedData = decryptData(response?.data);
      consoleLog(["HISTORY Details", decryptedData ? JSON.parse(decryptedData)?.data : null])
      return decryptedData ? JSON.parse(decryptedData)?.data : null;
    } else return null;
  } catch (error: any) {
    return null;
  }
}
